import React from 'react';
import { AlertBell } from '@yme/assets/icons';
import { Alert, AlertType } from '@yme/atoms/alert';
import { useSelector } from '@yme/hooks/useSelector';
import { getLinkForTestRide, getProductFilterOptions, getTestRideAvailableLoadingStatus, } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/common';
import { getMotorcycleVariationsStatus } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { checkBoatsProductType } from '@yme/utils/productTypes';
export function TestRideMessageForVariations({ productCampaignIDAttribute, eCommerceEnabledAttributeForMaster, }) {
    const { t } = useTranslation();
    const isRightToLeft = useSelector(getRTL);
    const isMotorcycleVariationsExisted = useSelector(getMotorcycleVariationsStatus);
    const linkForTestRide = useSelector(getLinkForTestRide);
    const isTestRideLoaded = useSelector(getTestRideAvailableLoadingStatus);
    const { productType } = useSelector(getProductFilterOptions);
    const isBoatProductType = checkBoatsProductType(productType);
    const isNotifyMe = productCampaignIDAttribute && !eCommerceEnabledAttributeForMaster;
    if (!isMotorcycleVariationsExisted ||
        !isTestRideLoaded ||
        linkForTestRide ||
        isNotifyMe ||
        isBoatProductType) {
        return null;
    }
    return (React.createElement(FlexWrapper, { mt: "20px", flexDirection: "column" },
        React.createElement(Alert, { message: t('productCard_testRideNotAvailableVariant_message'), type: AlertType.WARNING, customIcon: AlertBell, isRightToLeft: isRightToLeft })));
}
